import Joi from '@hapi/joi'

export const DailyCheckRoleSummarySchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
    pluckingType: Joi.string().invalid(0).required().label("pluckingType").messages({
        "any.invalid": `Please select valid Plucking Type`,
        "any.required": `Plucking Type required`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),

}

